import { Dialog, DialogContent, styled } from '@mui/material';

import FileBrowser from './FileBrowser';

interface IFileBrowserDialogProps {
  onClose: () => void;
  onFilesSelected?: (files: string[]) => void;
  selectMultiple?: boolean;
}

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: theme.shape.borderRadius * 1.5,
  },
}));

const FileBrowserDialog = ({
  onClose,
  onFilesSelected,
  selectMultiple,
}: IFileBrowserDialogProps) => (
  <StyledDialog
    // eslint-disable-next-line react/jsx-boolean-value
    open={true}
    maxWidth="lg"
    onClose={onClose}
    fullWidth
  >
    <DialogContent sx={{ p: { xs: 1.5, md: 2 } }}>
      <FileBrowser
        onSelectFiles={onFilesSelected}
        selectMultiple={selectMultiple}
        onClose={onClose}
      />
    </DialogContent>
  </StyledDialog>
);

export default FileBrowserDialog;
